import { render, staticRenderFns } from "./suggestDoctorEmptyState.vue?vue&type=template&id=fa0ed4c2&scoped=true"
import script from "./suggestDoctorEmptyState.vue?vue&type=script&lang=js"
export * from "./suggestDoctorEmptyState.vue?vue&type=script&lang=js"
import style0 from "./suggestDoctorEmptyState.vue?vue&type=style&index=0&id=fa0ed4c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0ed4c2",
  null
  
)

export default component.exports